export const MANGA_CALL_REQUEST = "MANGA_CALL_REQUEST";
export const MANGA_CALL_SUCCESS = "MANGA_CALL_SUCCESS";
export const MANGA_CALL_FAILURE = "MANGA_CALL_FAILURE";
